module.exports = __webpack_public_path__ + "static/media/imajinarium.e1b17b49.svg";